import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchJewellerReportRequest,
  fetchJewellerReportSuccess,
  fetchJewellerReportFailure,
} from "./JewellerReportSlice";

function* fetchJewellerReportSaga(action) {
  try {
    const {
      startDate = "",
      endDate = "",
      start = 0,
      limit = 10,
      search = "",
    } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller/getReport`,
        {
          params: {
            startDate,
            endDate,
            start,
            limit,
            search,
          },
        }
      )
    );

    const resData = response.data;

    if (resData) {
      yield put(
        fetchJewellerReportSuccess({
          report: resData,
          message: "Report fetched successfully",
        })
      );
    } else {
      yield put(fetchJewellerReportFailure("Failed to fetch report"));
    }
  } catch (error) {
    yield put(fetchJewellerReportFailure(error.message));
  }
}

export function* watchJewellerReportSaga() {
  yield takeLatest(fetchJewellerReportRequest.type, fetchJewellerReportSaga);
}
